import React from 'react';
import { Meteor } from 'meteor/meteor';

import {
	Row,
	Col,
	Grid,
	Panel,
	PanelBody,
	PanelContainer,
	Button,
	ButtonToolbar
} from '@sketchpixy/rubix';
import { AlertsViewer } from '../alerts/AlertsViewer';
import { Weather } from '../../external_api/weather';

export default class HomePage extends React.Component {

	constructor(props) {
		super(props);
		this.state = {};

		if(_.includes(Meteor.user().roles, 'partner'))
			this.state.partner = true;

		let that = this;
		Meteor.call('getEnv', 'CLIENT_NAME', function(err, result) {
			that.setState({ CLIENT_NAME : result });
   		});

   	}

	render() {
		return (
			<PanelContainer>
				<Panel>
					<PanelBody style={{padding: 0, paddingBottom: 25}}>
						<Grid>
							<Row>
								<Col sm={5} className="col-welcome">
									<h3>Bienvenue sur l'intranet de {this.state.CLIENT_NAME}</h3>
									<AlertsViewer></AlertsViewer>
								</Col>
								{!this.state.partner &&
								<Col sm={7} className="col-weather" style={{ 'display': 'flex', 'align-items': 'center', 'justify-content': 'center'}}>
									<iframe id="wf-forecast-angers_lac-de-maine" src="https://www.windfinder.com/widget/forecast/angers_lac-de-maine?show_pressure=1&unit_temperature=c&show_day=1&show_rain=1&unit_rain=mm&days=4&unit_wind=kts&show_clouds=1&show_wind=1&show_temperature=1&show_waves=1&columns=2&unit_wave=m', '" scrolling="no" marginwidth="0" width="520px" height="520px" marginheight="0" frameborder="0" style={{'border':'none'}} ></iframe>								</Col>
								}
							</Row>
						</Grid>
					</PanelBody>
				</Panel>
			</PanelContainer> 
		);
	}
}



/** WEBPACK FOOTER **
 ** ./src/universal/components/home/page-home.js
 **/